export interface GetCreativeParams {
  projectId: string
  creativeId: string
}

const endpoints = {
  getCreative: ({ projectId, creativeId }: GetCreativeParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/creatives/${creativeId}`
  },
}

export default endpoints
